import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import Table from "../Table";
import { useSelector, useDispatch } from "react-redux";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import { goalDetails } from "./CJApi"

var offSet = 0;
var matchNextButton = 1;
const GoalDetails = (props) => {
    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const { role , companyType} = useSelector(state => state.userSetter)

    const { companyUserLoading } = useSelector(
        (state) => state.companyUserSetter
    );
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setCompanyUserLoading(true));
    }, []);

    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;


        //setnoOfDays(noOfDaysV);
        setPageIndex(pageIndex);

        // getSessionsCount(noOfDaysV).then(data => {

        // })
        var url_string = window.location.href;
        var url = new URL(url_string);
        var idd = url.searchParams.get("id");




        if (props.history.location.state) {


            let type = props.history.location.state.prev ? 'previous' : ''

            let goal = props.history.location.state.goal
            let noOfDays = props.history.location.state.noOfDays
            let count = type == 'previous' ? goal.previousCount : goal.currentCount

            setPageCount(Math.ceil(count / pageSize));
            setTotal(count);

            goalDetails(goal.goalId.id, type, pageSize, startRow, goal.numberOfDays).then((data) => {
                data.forEach((g) => {
                    g.firstName = g.personId ? g.personId.firstName : ''
                    g.lastName = g.personId ? g.personId.lastName : ''
                    g.email = g.personId ? g.personId.email : ''
                    g.matchStatus = g.matchStatus ? g.matchStatus : '';
                    g.date = g.createAt ? g.createAt : '';
                    g.amount = g.leadGenRevenue ? '$'+Number.parseFloat(g.leadGenRevenue).toFixed(2) : '';
                    g.comment = g.comment ? g.comment : '';


                })
                setDataApi(data)

                dispatch(setCompanyUserLoading(false));
            })
        }
        // getSessionsAnalytics(noOfDaysV, pageSize, startRow).then((data) => {
        //     data.forEach((d) => {
        //         d.email = d.person[0] ? d.person[0].email : "";
        //         let ipA = d.ipAddress ? d.ipAddress.slice(0, 3) : [];
        //         ipA = ipA.join(' | ')
        //         d.ipAddress = ipA
        //     });
        //     setDataApi(data);
        //     dispatch(setCompanyUserLoading(false));
        //     //  /webpageAnalytics/sessions/count, /webpageAnalytics/users/count
        // });

        dispatch(setCompanyUserLoading(false));
    }, []);

    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => role== 'publisher'? [
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Last Channel",
                accessor: "lastChannelLabel",
            },

            {
                Header: "Last Campaign",
                accessor: "lastCampaignName",
            },
            {

                Header: "Ip Address",
                accessor: "ipAddress",
            },
            {
                Header: "First Name",
                accessor: "firstName",
            },
            {
                Header: "Last Name",
                accessor: "lastName",
            },
            {
                Header: "Match Status",
                accessor: "matchStatus",
              },
              {
                Header: " Rev-share Amount",
                accessor: "amount",
              },
              {
                Header: "Date",
                accessor: "date",
              },
              {
                Header: "Comment",
                accessor: "comment",
              },
             


        ]: companyType='lead'?[
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Last Channel",
                accessor: "lastChannelLabel",
            },

            {
                Header: "Last Campaign",
                accessor: "lastCampaignName",
            },
            {

                Header: "Ip Address",
                accessor: "ipAddress",
            },
            {
                Header: "First Name",
                accessor: "firstName",
            },
            {
                Header: "Last Name",
                accessor: "lastName",
            },
            {
                Header: "Match Status",
                accessor: "matchStatus",
              },
              {
                Header: "Date",
                accessor: "date",
              },
              {
                Header: "Comment",
                accessor: "comment",
              },
             


        ]:[
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Last Channel",
                accessor: "lastChannelLabel",
            },

            {
                Header: "Last Campaign",
                accessor: "lastCampaignName",
            },
            {

                Header: "Ip Address",
                accessor: "ipAddress",
            },
            {
                Header: "First Name",
                accessor: "firstName",
            },
            {
                Header: "Last Name",
                accessor: "lastName",
            },


        ],
        []
    );

    return (
        <Container>
            <div className="page_heading">
                <h2>Goal details</h2>
                <h6>{props.history.location.state.goal.goalId.name}</h6>
                <button
                    className="btn btn-sm"
                    style={{ color: "#114169" }}
                    onClick={() => props.history.push(`/admin/dashboard`)}
                >{`< Back`}</button>
                <p className="sm d-flex align-items-center">

                    <span className="inline-label ml-auto">
                        Page No. {pageIndex + 1} of {pageCount}
                    </span>
                </p>
            </div>
            <div></div>
            {dataApi ? (
                <div className="dataTableOuter">
                    {
                        <Table
                            columns={columns}
                            data={data}
                            pageCount={pageCount}
                            fetchData={fetchData}
                        // loading={companyUserLoading}
                        ></Table>
                    }
                </div>
            ) : (
                <ContactLoader />
            )}
        </Container>
    );
};

export default GoalDetails;
